import { HeaderAndTableCellDraft, SortAttributes, TableActionElement, TableDraft, TableVariant } from './table.models';

interface Builder<T> {
  build(): T;
}

export class TableDraftBuilder implements Builder<TableDraft> {
  private readonly draft: TableDraft;

  constructor(headerAndTableCells: HeaderAndTableCellDraft[]) {
    this.draft = {
      headerAndTableCells: headerAndTableCells,
    };
  }

  hiddenColumns(columnIds: string[]): this {
    this.draft.hiddenColumns = columnIds;
    return this;
  }

  sortableColumns(columnIds: string[]): this {
    this.draft.sortColumnIds = columnIds;
    return this;
  }

  checkboxes(enabled = true): this {
    this.draft.showCheckBoxes = enabled;
    return this;
  }

  radiobuttons(enabled = true): this {
    this.draft.showRadioButtons = enabled;
    return this;
  }

  sort({ sortField, sortOrder }: SortAttributes): this {
    this.draft.sortStartDirection = sortOrder ?? 'asc';
    this.draft.sortStartColumnId = sortField;
    return this;
  }

  disableRowLink(disabled = true): this {
    this.draft.disabledRowLink = disabled;
    return this;
  }

  setRowControl(control = false): this {
    this.draft.rowClickControl = control;
    return this;
  }

  disabledRow(callback: (obj: unknown) => boolean): this {
    this.draft.disabledRow = callback;
    return this;
  }

  rowLink(link: string[]): this {
    this.draft.rowLink = link;
    return this;
  }

  tableVariant(variant: TableVariant): this {
    this.draft.tableVariant = variant;
    return this;
  }

  actions(actions: TableActionElement[]): this {
    if (actions.length) {
      this.draft.headerAndTableCells = [
        ...this.draft.headerAndTableCells,
        {
          headerCellColumnId: 'actions',
          headerCellTranslationKey: '',
          tableCellContentKey: 'id',
          actionElements: actions,
          tableCellContentType: 'ACTION',
        },
      ];
    }
    return this;
  }

  build(): TableDraft {
    return this.draft;
  }
}
